export const manifest = {
  screens: {
    scr_r7fwnk: { name: "The Venture Brain Is Awake.", route: "/", state: {"slideIndex":0}, position: {"x":160,"y":220} },
    scr_prob01: { name: "Venture has spent 80 years creating data.", route: "/", state: {"slideIndex":1}, position: {"x":1560,"y":220} },
    scr_whyn02: { name: "Every venture decision creates data.", route: "/", state: {"slideIndex":2}, position: {"x":2960,"y":220} },
    scr_insi03: { name: "More data than ever — less time to build conviction.", route: "/", state: {"slideIndex":3}, position: {"x":4360,"y":220} },
    scr_solu04: { name: "DiligenceGPT™ turns deal flow into investment intelligence.", route: "/", state: {"slideIndex":4}, position: {"x":5760,"y":220} },
    scr_loop05: { name: "From raw startup data to conviction in one workspace.", route: "/", state: {"slideIndex":5}, position: {"x":7160,"y":220} },
    scr_room06: { name: "Sony Innovation Fund is expanding coverage in Canada.", route: "/", state: {"slideIndex":6}, position: {"x":8560,"y":220} },
    scr_moat07: { name: "Built with — and trusted across — the venture ecosystem.", route: "/", state: {"slideIndex":7}, position: {"x":9960,"y":220} },
    scr_edge08: { name: "Enterprise adoption is converting into recurring revenue.", route: "/", state: {"slideIndex":8}, position: {"x":11360,"y":220} },
    scr_trac09: { name: "A recurring software model with enterprise contracts.", route: "/", state: {"slideIndex":9}, position: {"x":12760,"y":220} },
    scr_mark10: { name: "Every customer makes the intelligence layer more valuable.", route: "/", state: {"slideIndex":10}, position: {"x":14160,"y":220} },
    scr_bmod11: { name: "Enter through workflows, expand into infrastructure.", route: "/", state: {"slideIndex":11}, position: {"x":15560,"y":220} },
    scr_posi12: { name: "Enterprise proof opens the door; ecosystem expands it.", route: "/", state: {"slideIndex":12}, position: {"x":16960,"y":220} },
    scr_gtmk13: { name: "Built by venture operators, builders and AI experts.", route: "/", state: {"slideIndex":13}, position: {"x":18360,"y":220} },
    scr_team14: { name: "Building the intelligence infrastructure for venture capital.", route: "/", state: {"slideIndex":14}, position: {"x":19760,"y":220} },
    scr_ask015: { name: "Sources, definitions and methodology.", route: "/", state: {"slideIndex":15}, position: {"x":21160,"y":220} },
  },
  sections: {
    sec_1kdz38: { name: "DiligenceGPT pitch narrative", x: 0, y: 0, width: 23920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_1kdz38", children: [
      { kind: "screen", id: "scr_r7fwnk" },
      { kind: "screen", id: "scr_prob01" },
      { kind: "screen", id: "scr_whyn02" },
      { kind: "screen", id: "scr_insi03" },
      { kind: "screen", id: "scr_solu04" },
      { kind: "screen", id: "scr_loop05" },
      { kind: "screen", id: "scr_room06" },
      { kind: "screen", id: "scr_moat07" },
      { kind: "screen", id: "scr_edge08" },
      { kind: "screen", id: "scr_trac09" },
      { kind: "screen", id: "scr_mark10" },
      { kind: "screen", id: "scr_bmod11" },
      { kind: "screen", id: "scr_posi12" },
      { kind: "screen", id: "scr_gtmk13" },
      { kind: "screen", id: "scr_team14" },
      { kind: "screen", id: "scr_ask015" },
      { kind: "screen", id: "scr_clos16" },
    ] },
  ],
}
